import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { accountDetailPath } from '../../lib/portal';
import type { Client } from '../../types/crm';
import { AccountAvatar } from './AccountAvatar';

interface AccountSubCompaniesPanelProps {
  parent: Client;
  subCompanies: Client[];
  canEdit: boolean;
  onAdd: () => void;
}

export function AccountSubCompaniesPanel({
  parent,
  subCompanies,
  canEdit,
  onAdd,
}: AccountSubCompaniesPanelProps) {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(false);
  }, [parent.id, subCompanies.length]);

  return (
    <section className="card account-sub-companies">
      <div className="account-sub-companies__head">
        <h2 className="account-sub-companies__title">Brands &amp; sub-companies</h2>
        {canEdit && (
          <button type="button" className="btn-secondary btn-sm" onClick={onAdd}>
            + Add sub-company
          </button>
        )}
      </div>

      {subCompanies.length === 0 ? (
        <p className="account-sub-companies__empty">No sub-companies yet.</p>
      ) : expanded ? (
        <>
          <ul className="account-sub-companies__list account-sub-companies__list--expanded">
            {subCompanies.map((sub) => (
              <li key={sub.id} className="account-sub-companies__item">
                <Link to={accountDetailPath(sub.code)} className="account-sub-companies__link">
                  <AccountAvatar client={sub} size="sm" className="account-sub-companies__avatar" />
                  <span className="account-sub-companies__text">
                    <span className="account-sub-companies__name">{sub.company_name}</span>
                    <span className="account-sub-companies__meta">
                      {sub.code}
                      {sub.owner_id?.trim() ? ` · ${sub.owner_id.trim()}` : ''}
                    </span>
                  </span>
                </Link>
                <span className="account-sub-companies__chevron" aria-hidden>
                  ›
                </span>
              </li>
            ))}
          </ul>
          <button
            type="button"
            className="account-side-view-all account-sub-companies__more"
            onClick={() => setExpanded(false)}
          >
            Show less
          </button>
        </>
      ) : (
        <button
          type="button"
          className="account-side-view-all account-sub-companies__more"
          onClick={() => setExpanded(true)}
        >
          Show more ({subCompanies.length})
        </button>
      )}
    </section>
  );
}
